<template>

  <div id="article">
    <section class="hsMaxBox">
      <el-menu default-active="0" class="el-menu-demo" active-text-color="#00b9cd" mode="horizontal" @select="handleSelect">
        <el-submenu  class="box-nav" index="0">
          <template slot="title"><label class="boxT">文章分类</label></template>
          <el-menu-item index="0">全部</el-menu-item>
          <label v-for="(item,i) in tags"><el-menu-item :index="tags[i].id">{{tags[i].name}}</el-menu-item></label>
        </el-submenu>
      </el-menu>
      <ul
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="10">
        <li v-for="(item,i) in list">
          <a target="_blank" :href='""+host+"/html/news/detail-"+list[i].id+".html"'>
            <p class="hsDynamicLi">
              <img class="hsDynamicTu" :src='""+host+""+list[i].title_img+""'></img>

              <!--<i class="hsDynamicTu" :style='"background: url("+host+list[i].title_img+") no-repeat center;background-size: cover"'></i>
              -->
              <span class="hsDynamicLiText">
            <label class="hsDynamicTop">{{list[i].title}}</label>
            <label class="hsDynamicBottom">{{list[i].add_time}}</label>
          </span>
            </p>
          </a>
        </li>
      </ul>
    </section>
    <!--至顶-->
    <i @click="toTop" class="toTop"></i>
  </div>
</template>

<script>
  let wind_width = parseInt(window.screen.width);
  let mobile_wi = wind_width/750;
  let isAndroid = RegExp("Android").test(navigator.userAgent);
  if(isAndroid) {
    document.write('<meta name="viewport" content="width=750, minimum-scale = '+mobile_wi+', maximum-scale = '+mobile_wi+', target-densitydpi=device-dpi">');
  }else{
    document.write('<meta name="viewport" content="width=750, user-scalable=no, target-densitydpi=device-dpi">');
  }

  export default {
  name: '',
  data () {
    return {
    	host: this.GLOBAL.host,
      list:{},
      tags:[],
      page:1,
      tag_id:0,
    }
  },
  methods: {
    //导航选中事件
    handleSelect(vai){
      this.tag_id=vai;
      this.article(this.tag_id,1);
    },
    toTop(){
      window.scrollTo(0,0);
    },
    loadMore() {
      this.loading = true;
      this.page+=1;
      this.$http.get(this.host+'/site/article.html?tag_id='+this.tag_id+'&page='+this.page+'').then((response) => {
        setTimeout(() => {
          for (let i = 1; i <= response.data.data.list.length; i++) {
            this.list.push(response.data.data.list[i-1]);
          }
          this.loading = false;
        }, 1000);
      }, (response) => {});
      },
    article(tag_id,page){
      this.$http.get(this.host+'/site/article.html?tag_id='+tag_id+'&page='+page+'').then((response) => {
        this.list=response.data.data.list;
        return false;
      }, (response) => {});
    }
  },
    created: function () {
      this.article(0,1)
      this.$http.get(this.host+'/site/articleClassifyTag.html').then((response) => {
        this.tags=response.data.data;
      }, (response) => {});
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #article{text-align: center}
  .hsMaxBox{padding-bottom: 40px}
  .box-nav{margin-top: 134px}
  .boxT{font-size: 22px !important;}
  .el-menu-demo{margin-bottom: 40px}
  .hsDynamicLi{position: relative;height: 170px;margin-bottom: 40px;border-bottom: 1px solid #d9d9d9;padding-bottom: 40px}
  .hsDynamicTu{width: 190px;height: 190px;border-radius: 10px;margin-right: 10px}
  .hsDynamicTop{display: inline-block; height: 115px; overflow: hidden; color: #333;font-size: 28px;position: absolute;top:0}
  .hsDynamicBottom{color: #999;font-size: 24px;position: absolute;bottom: 0;}
  .hsDynamicLiText{width: 450px;display: inline-block;height: 170px;vertical-align: top;text-align: left;position: relative}
  .toTop{background: url("../../site/toTop.png");width: 90px;height: 90px;position: fixed;bottom: 20px;right: 20px}
</style>



// WEBPACK FOOTER //
// article.vue?d7528dda